export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_1600kbps-1f110f049f1c5329b23117b62685db9d.avif";